export { BarChart, type BarChartProps } from './BarChart';
